// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { createStaffData } from "../../../features/staff";
import { getRoleData } from "../../../features/role";

const AddStaff = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: roles } = useSelector((state: any) => state.roles);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role_id: "",
    companyCode: "",
  });

  useEffect(() => {
    if (!(roles && roles.length > 0)) {
      dispatch(getRoleData({ page: 1, limit: 100 }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.password) {
      toast.error("Name and password are required.");
      return;
    }
    dispatch(createStaffData({ data: formData }))
      .then((action) => {
        if (createStaffData.rejected.match(action)) {
          toast.error(action.error.message || "Failed to create staff.");
        } else {
          toast.success(action.payload.message || "Staff created successfully.");
          navigate("/staffs");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Failed to create staff.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Staff
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter staff name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Email
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="email"
              name="email"
              placeholder="Enter staff email"
              value={formData.email}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Password
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="password"
              name="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                mb={1}
              >
                Role
              </SoftTypography>
              <Select
                id="role_id"
                name="role_id"
                value={formData.role_id}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                displayEmpty
                sx={{
                  height: "40px !important",
                  ".MuiSelect-select": {
                    padding: "0px 14px !important",
                    height: "40px !important",
                    display: "flex !important",
                    alignItems: "center",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select a role
                </MenuItem>
                {roles &&
                  roles.map((role) => (
                    <MenuItem
                      key={role._id}
                      value={role._id}
                      sx={{ marginBottom: "5px" }}
                    >
                      {role.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Company Code
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="companyCode"
              placeholder="Enter company code"
              value={formData.companyCode}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              type="submit"
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddStaff;